import { render, staticRenderFns } from "./SupportTicketButton.vue?vue&type=template&id=e6426344"
import script from "./SupportTicketButton.vue?vue&type=script&lang=js"
export * from "./SupportTicketButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default,SupportTicketDialog: require('/vercel/path0/components/partials/support_ticket/SupportTicketDialog.vue').default})
